




















































































































import * as analyticHelper from '@/lib/analytic-helper';
import {
  Component,
  Prop,
  Vue,
  Provide,
  Watch,
  Emit,
  Ref,
} from 'vue-property-decorator';
import {
  ClassLogo,
  SwitchIcon,
  WhatsNewIcon,
  SettingsIcon,
  QuestionMarkIcon,
  ClientViewIcon,
  ChangeBusinessIcon,
  ClassAgentIcon,
  ClassAgentIconHover,
} from '../../assets/icons';
import IconButton from '../_icon-button/icon-button.vue';
import EntityResultsPanel from '../_entity-results-panel/entity-results-panel.vue';
import MainResultsPanel from '../_main-results-panel/main-results-panel.vue';
import { SidebarState } from '../../store';
import { namespace } from 'vuex-class';
import { IClassAgentConfig } from '../../store/SidebarState/types';
const sidebarState = namespace('SidebarState');
@Component({
  name: 'AxSearchbar',
  components: {
    ClassLogo,
    SwitchIcon,
    SettingsIcon,
    WhatsNewIcon,
    QuestionMarkIcon,
    ClientViewIcon,
    ChangeBusinessIcon,
    ClassAgentIcon,
    ClassAgentIconHover,
    IconButton,
    EntityResultsPanel,
    MainResultsPanel,
  },
})
export default class AxSearchbar extends Vue {
  @Prop({ required: false }) public clientViewPath: string;
  @Prop({ required: false }) public classAgent: IClassAgentConfig;
  @Prop({ required: false }) public enableHelpPanel: any;
  @sidebarState.Getter isSidebarOpen: boolean;
  @sidebarState.Action closeSidebar: () => void;
  @sidebarState.Action toggleSidebar: () => void;
  @sidebarState.Getter isSettingsPanelOpen: boolean;
  @sidebarState.Action closeSettings: () => void;
  @sidebarState.Action toggleSettings: () => void;
  @sidebarState.Getter isWhatsNewPanelOpen: boolean;
  @sidebarState.Action closeWhatsNew: () => void;
  @sidebarState.Action toggleWhatsNew: () => void;
  @sidebarState.Getter isHelpPanelOpen: boolean;
  @sidebarState.Action closeHelp: () => void;
  @sidebarState.Action toggleHelp: () => void;
  @sidebarState.Mutation setEnableHelpPanel: (enable: any) => void;
  public isSearchBoxFocused: boolean = false;
  private showResultPanel: boolean = false;
  private searchQuery: string = '';
  @Provide('searchText') public searchTextProvider() {
    return this.searchQuery;
  }
  @Emit('onUpKeyPressedInSearchbox') public onUpKeyPressedInSearchbox() {}
  @Emit('onDownKeyPressedInSearchbox') public onDownKeyPressedInSearchbox() {}
  @Emit('actionOnSelectedItem') public actionOnSelectedItem() {}
  @Emit('newFeatureToggled')
  public toggleNewFeature(e: Event) {
    const target = e.target as HTMLInputElement;
    return { newValue: target.checked };
  }
  @Emit('searchBoxFocused')
  public onFocusInSearchbox(e: Event) {
    this.showResultPanel = true;
    const input = e?.target as HTMLInputElement;
    input?.setSelectionRange(0, input?.value?.length);
    return e;
  }
  public tryCloseSidebar(e: Event): void {
    const nineDotButton = (this.$refs.nineDotButton as Vue).$el as HTMLElement;
    const eventTarget = e.target as HTMLElement;
    if (
      nineDotButton !== eventTarget &&
      !nineDotButton?.contains(eventTarget)
    ) {
      this.closeSidebar();
    }
  }
  public beforeCreate() {
    SidebarState.register?.(this.$store);
  }
  public destroyed() {
    SidebarState.unregister?.(this.$store);
  }
  public tryCloseSettings(e: Event): void {
    const settingsButton = this.$refs.settingsButton as HTMLElement;
    const eventTarget = e.target as HTMLElement;
    if (
      settingsButton !== eventTarget &&
      !settingsButton?.contains(eventTarget)
    ) {
      this.closeSettings();
    }
  }
  public tryWhatsNewWhatsNewSettings(e: Event): void {
    const whatsNewButton = this.$refs.whatsNewButton as HTMLElement;
    const eventTarget = e.target as HTMLElement;
    if (
      whatsNewButton !== eventTarget &&
      !whatsNewButton?.contains(eventTarget)
    ) {
      this.closeWhatsNew();
    }
  }
  public onMouseUpInSearchbox(e: Event) {
    this.showResultPanel = true;
  }
  public onKeyDownInSearchbox(e: KeyboardEvent) {
    if (e.shiftKey || e.metaKey || e.altKey || e.ctrlKey) {
      return;
    }
    if (e.key === 'ArrowUp') {
      this.showResultPanel = true;
      this.onUpKeyPressedInSearchbox();
      e.preventDefault();
    } else if (e.key === 'ArrowDown') {
      this.onDownKeyPressedInSearchbox();
      this.showResultPanel = true;
      e.preventDefault();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      this.actionOnSelectedItem();
    } else if (e.key === 'Escape') {
      this.showResultPanel = false;
    } else if (e.key === 'Tab') {
      this.showResultPanel = false;
    }
  }
  public onControlSlashKeyPressed() {
    this.txtSearchBox.focus();
  }
  @Ref('txtSearchBox')
  public readonly txtSearchBox!: HTMLInputElement;
  @Ref('mainResultsPanel')
  public readonly mainResultsPanel!: any;

  @Emit('navigate') public navigate(e: Event) {
    console.log('navigated');
    this.showResultPanel = false;
    return e;
  }
  @Watch('enableHelpPanel')
  onEnableHelpPanelChange(val: any) {
    this.setEnableHelpPanel(val);
  }

  public mounted() {
    this.setEnableHelpPanel(this.enableHelpPanel);
    window.addEventListener('click', this.onClickOutside);
    const parentVueNode = this.$parent;
    if (parentVueNode.$el.classList.contains('ax-powerbar')) {
      parentVueNode.$on('onPowerbarMouseUp', this.onPowerbarMouseUp);
    }
  }
  public unmounted() {
    window.removeEventListener('click', this.onClickOutside);
    const parentVueNode = this.$parent?.$parent?.$parent;
    if (parentVueNode.$el.classList.contains('ax-powerbar')) {
      parentVueNode.$off('onPowerbarMouseUp');
    }
  }
  public onPowerbarMouseUp(e: MouseEvent) {
    const target = e.target;
    if (this.txtSearchBox?.contains(target as Node)) {
      return;
    }
    if (this.mainResultsPanel?.$el?.contains(target as Node)) {
      return;
    }
    this.showResultPanel = false;
  }
  public onClickOutside(e: Event) {
    if (!this.txtSearchBox || !this.mainResultsPanel) {
      return;
    }
    if (this.txtSearchBox.contains(e.target as Node)) {
      return;
    }
    if (this.mainResultsPanel.$el.contains(e.target as Node)) {
      return;
    }
    if ((e.target as any)?.nodeName?.toUpperCase() === 'AXC-POWERBAR') {
      return;
    }
    if (
      (e.target as any)?.shadowRoot &&
      ((e.target as any)?.shadowRoot?.contains(this.txtSearchBox) ||
        (e.target as any)?.shadowRoot?.contains(this.mainResultsPanel))
    ) {
      return;
    }
    this.showResultPanel = false;
  }
  public get classAgentEnabled() {
        return this.classAgent?.enabled;
    }

    public get classAgentUrl() {
        return this.classAgent?.url;
    }
}
